module.exports = __webpack_public_path__ + "img/consultation.fc1077fa.png";